import { get, post, patch, formatUrl, deleteMethod, postJson } from '../../../utils/request'
import {
  GET_LIST_BANK,
  GET_LIST_MOMO,
  REQUEST_BANK_ACCOUNT,
  ADD_TOPUP,
  VERIFY_TOPUP,
  PAYMENT_TRANSFER,
  GET_LIST_TRANSACTION,
  GET_AVAILABLE_BALANCE,
  REQUEST_VISA_CARD,
  VERIFY_CARD_TOPUP,
  PROCESS_PAYMENT,
  MOBILE_TRANSFER,
  GET_LIST_BANK_LIST,
  GET_LIST_BANK_BRANCH_LIST
} from '../../../utils/urls'

const actions = {

  requestGetListBank: async (context, payload) => {
    // list bank
    if (!payload || !payload.isMomo) {
      try {
        let response = await get(GET_LIST_BANK)
        let status = response.status
        if (status === 200) {
          context.commit('setListBank', response.data)
        }
      } catch (e) {
        context.commit('setListBank', [])
      }
    } else {
      // list momo
      try {
        let response = await get(GET_LIST_MOMO)
        let status = response.status
        if (status === 200) {
          context.commit('setListMomo', response.data)
        }
      } catch (e) {
        context.commit('setListMomo', [])
      }
    }
  },
  getAllBanks: async (context, payload) => {
    try {
      const {countryCode} = payload
      return await get(`${GET_LIST_BANK_LIST}/${countryCode}`)
    } catch (e) {
      console.log(e)
    }
  },

  getAllBankBranches: async (context, payload) => {
    try {
      const {branchCode} = payload
      return await get(`${GET_LIST_BANK_BRANCH_LIST}/${branchCode}`)
    } catch (e) {
      console.log(e)
    }
  },

  requestAddBankAccount: async (context, payload) => {
    let response = await post(REQUEST_BANK_ACCOUNT, payload)
    return response
  },

  requestGetBankAccount: async (context, payload) => {
    let response = null
    let typeList = null
    try {
      if (!payload || !payload.is_momo) {
        response = await get(REQUEST_BANK_ACCOUNT + '?employer_id=' + payload.currentBusinessAccount.id)
        typeList = 'setListBankAccount'
      } else {
        response = await get(REQUEST_BANK_ACCOUNT + '?is_momo=true&employer_id=' + payload.currentBusinessAccount.id)
        typeList = 'setListMomoAccount'
      }
      let status = response.status
      if (status === 200) {
        // filter according to business account
        const result = response.data.results.filter((account) => {
          return account.employer.id === payload.currentBusinessAccount.id
        })
        context.commit(typeList, result)
      }
    } catch (e) {
      context.commit(typeList, [])
    }
  },

  requestPatchBankAccount: async (context, payload) => {
    const { id, ...data } = payload
    const uri = REQUEST_BANK_ACCOUNT + id + '/'
    const response = await patch(uri, data)
    return response
  },

  requestDeleteBankAccount: async (context, payload) => {
    const uri = REQUEST_BANK_ACCOUNT + payload.id + '/'
    const response = await deleteMethod(uri, payload)
    return response
  },

  requestAddTopUp: async (context, payload) => {
    let uri = ADD_TOPUP
    if (payload.isCard) {
      uri = ADD_TOPUP + 'card/'
    }
    let response = await post(uri, payload)
    return response
  },
  requestVerifyTopUp: async (context, payload) => {
    let uri = VERIFY_TOPUP
    if (payload.isCard) {
      uri = VERIFY_CARD_TOPUP
    }
    let response = await post(uri, payload)
    return response
  },

  requestPaymentTransfer: async (context, payload) => {
    let response = await post(PAYMENT_TRANSFER, payload)
    return response
  },

  requestMobilePaymentTransfer: async (context, payload) => {
    let response = await post(MOBILE_TRANSFER, payload)
    return response
  },

  requestGetListTransaction: async (context, payload) => {
    let response = await get(GET_LIST_TRANSACTION, payload.params)
    return response
  },

  requestGetListCards: async (context, payload) => {
    try {
      let response = await get(REQUEST_VISA_CARD)
      let status = response.status
      if (status === 200) {
        context.commit('setListVisaCards', response.data.results)
      }
    } catch (e) {
      context.commit('setListVisaCards', [])
    }
  },
  requestAddVisaCard: async (context, payload) => {
    let response = await postJson(PROCESS_PAYMENT, payload)
    return response
  },
  requestPatchVisaCard: async (context, payload) => {
    const uri = REQUEST_VISA_CARD + payload.id + '/'
    const response = await patch(uri, payload)
    return response
  },
  requestDeleteVisaCard: async (context, payload) => {
    const uri = REQUEST_VISA_CARD + payload.id + '/'
    const response = await deleteMethod(uri, payload)
    return response
  },

  getAvailableBalance: async (context, payload) => {
    try {
      let url = formatUrl(GET_AVAILABLE_BALANCE, payload.params)
      let response = await get(url)
      let status = response.status
      if (status === 200) {
        context.commit('setAvailableBalance', response.data)
      }
    } catch (e) {
      context.commit('setAvailableBalance', 0)
    }
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/e-wallet/actions.js